"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 配置NProgress
NProgress.configure({
  minimum: 0.3,
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
});

export function LoadingIndicator() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // 当路由变化时，启动进度条
    NProgress.start();

    // 路由加载完成后，完成进度条
    const timer = setTimeout(() => {
      NProgress.done();
    }, 500); // 给一个小延迟，确保进度条效果明显

    return () => {
      clearTimeout(timer);
      NProgress.done();
    };
  }, [pathname, searchParams]);

  return null; // 这个组件不渲染任何UI元素
} 